<template>
    <div class="page-container has-action">
        <van-nav-bar left-arrow title="编辑收货地址" @click-left="goableBack()"></van-nav-bar>
        <div class="page">
            <div class="bg-color-white ">
                <van-field
                        v-model="form.fields.receiveName"
                        clearable
                        placeholder="收货人姓名"
                />
                <van-field
                        v-model="form.fields.phone"
                        clearable
                        placeholder="收货人手机号码"
                />
                <van-field
                        v-model="pickerRegion.text"
                        readonly
                        placeholder="所在地区"
                        @blur="pickerRegion.show = true"
                />
                <van-field
                        v-model="form.fields.address"
                        type="textarea"
                        autosize
                        clearable
                        placeholder="详细地址(街道门牌、楼层房间号等)"
                />
            </div>
            <div class="mt-10 bg-color-white">
                <van-switch-cell v-model="form.fields.isDefault" title="设为默认地址"/>
            </div>
            <div class="mt-50 px-20">
                <van-button type="danger" block  size="large" @click="onSubmit">保存</van-button>
                <van-button class="mt-20" v-if="form.fields.id > 0" type="danger" size="large" block plain   @click="onDel">删除</van-button>
            </div>
        </div>
        <van-popup v-model="pickerRegion.show"  position="bottom" @opened="setRegionValues" >
            <van-picker ref="pickerRegion"
                        valueKey="name"
                        show-toolbar
                        :loading="pickerRegion.loading"
                        :columns="pickerRegion.columns"
                        @cancel="pickerRegion.show = false"
                        @confirm="onRegionConfirm"
                        @change="onRegionChange"

            />
        </van-popup>
    </div>
</template>

<script>
    import {Field, SwitchCell, Popup, Picker,Toast} from "vant";
    import CommonApi from "@/api/common";
    import * as validate from "@/utils/validate";
    import * as CustApi from "@/api/cust";
    import * as GoodsApi from "@/api/goods";
    export default {
        name: "edit",
        data: () => ({
            pickerRegion:{
                show:false,
                loading:false,
                columns: [{ values: [] }, { values: [] }, { values: [] }],
                text:"",
            },

            form: {
                fields: {
                    id:"",
                    receiveName: "",
                    phone:"",
                    provinceId: "",
                    areaId: "",
                    cityId: "",
                    address:"",
                    isDefault:false,
                }
            },
            regionList: {},
            provinceList: {},
            areaList: {},
            cityList: {},
        }),
        beforeRouteEnter(to, from, next) {
            if(to.params.id) {
                GoodsApi.getPlace(to.params.id).then(data=>{
                    next(vm=>{
                        vm.setData(data);
                    })
                }).catch(e=>{

                });
            }else {
                next();
            }

        },
        beforeMount() {
            CommonApi.listRegion().then(data => {
                this.regionList = data;
                this.setRegionValues();
            }).then(e => {

            });
        },

        methods: {
            setData(data) {
                this.form.fields.id = data.id;
                this.form.fields.cityId = data.cityId;
                this.form.fields.provinceId = data.provinceId;
                this.form.fields.areaId = data.areaId;
                this.form.fields.receiveName = data.receiveName;
                this.form.fields.address = data.address;
                this.form.fields.phone = data.phone;
                this.form.fields.isDefault = data.isDefault;
                this.pickerRegion.text = `${data.provinceName}  ${data.areaName}  ${data.cityName}`
            },
            setRegionValues() {
                if (this.pickerRegion.loading) {
                    return;
                }
                const picker = this.$refs.pickerRegion;
                if(!picker) {
                    return ;
                }

                picker.setColumnValues(0, this.buildRegionColumn('province'));
                picker.setColumnValues(1, this.buildRegionColumn('area', this.form.fields.provinceId));
                picker.setColumnValues(2, this.buildRegionColumn('city', this.form.fields.areaId));

                picker.setIndexes([
                    this.getRegionIndex('province', this.form.fields.provinceId),
                    this.getRegionIndex('area', this.form.fields.areaId, this.form.fields.provinceId),
                    this.getRegionIndex('city', this.form.fields.cityId, this.form.fields.areaId)
                ]);
            },
            buildRegionColumn(type, parentId) {
                let result = [];
                const list = this.regionList[type + "List"];

                result = list.map(n => {
                    let tmp = {
                        id: n.id,
                    };
                    switch (type) {
                        case 'city':
                            tmp.parent = n.areaId;
                            tmp.name = n.cityName;
                            break;
                        case 'area':
                            tmp.parent = n.provinceId;
                            tmp.name = n.areaName;
                            break;
                        case 'province':
                            tmp.name = n.provinceName;
                            break;
                    }
                    return tmp;
                });

                result = result.filter(item => item.parent === parentId);
                if ( result.length) {
                    // set columns placeholder
                    result.unshift({
                        id: 0,
                        name: '请选择',
                        parentId:0
                    });
                }
                return result;
            },
            // get index by code
            getRegionIndex(type, id, parentId) {
                const list = this.buildRegionColumn(type, parentId);
                for (let i = 0; i < list.length; i++) {
                    if (list[i].id === id) {
                        return i;
                    }
                }
                return 0;
            },
            parseOutputValues(values,index) {
                return values.map((value, index) => {
                    // save undefined value
                    if (!value) return value;
                    value = JSON.parse(JSON.stringify(value));
                    if (!value.id || value.name === "请选择") {
                        value.id = '';
                        value.name = '';
                    }
                    return value;
                });
            },
            onRegionChange(picker, values, index) {
                values = this.parseOutputValues(values);
                switch (index) {
                    case 0:
                        this.form.fields.provinceId = values[index].id;
                        break;
                    case 1:
                        this.form.fields.areaId = values[index].id;
                        break;
                    case 2:
                        this.form.fields.cityId = values[index].id;
                        break;
                }
                this.setRegionValues();
            },
            onRegionConfirm(values, index) {
                values = this.parseOutputValues(values);
                if(values.some(n=>n.id < 1)) {
                    Toast("请选择地区");
                    return ;
                }
                this.pickerRegion.text = `${values[0].name}  ${values[1].name}  ${values[2].name}`;
                this.pickerRegion.show = false;
                this.setRegionValues();
            },
            onSubmit() {
                if(this.form.fields.receiveName.length < 1) {
                    Toast("请输入收货人姓名");
                    return ;
                }
                if(this.form.fields.phone.length <  1) {
                    Toast("请输入收货人手机号");
                    return ;
                } else if(!validate.mobile(this.form.fields.phone)) {
                    Toast("收货人手机号格式不对");
                    return ;
                }
                if(this.form.fields.address.length <  1) {
                    Toast("请输入详细地址");
                    return ;
                }
                if(this.form.fields.provinceId.length <  1 || this.form.fields.cityId.length < 1 || this.form.fields.areaId.length < 1) {
                    Toast("请选择地区");
                    return ;
                }
                if(this.form.fields.address.length <  1) {
                    Toast("请输入详细地址");
                    return ;
                }
                if(this.form.fields.id > 0) {
                    CustApi.addressDefault(this.form.fields).then(data=>{
                        Toast({
                            type:"success",
                            message: '修改成功',
                            onClose: ()=> {
                                if(this.$route.query.redirect) {
                                    this.$router.replace({name:this.$route.query.redirect});
                                } else {
                                    this.goableBack();
                                }
                            }
                        });
                    }).catch(e=>{

                    });
                } else {
                    CustApi.addAddress(this.form.fields).then(data=>{
                        Toast({
                            type:"success",
                            message: '保存成功',
                            onClose: ()=> {
                                if(this.$route.query.redirect) {
                                    this.$router.replace({name:this.$route.query.redirect,query:{addressId:data}});
                                } else {
                                    //this.$router.replace({name:"address"});
                                    this.goableBack();
                                }
                            }
                        });
                    }).catch(e=>{
                        console.info(e);
                    });
                }
            },
            onDel() {
                CustApi.delAddress(this.form.fields.id).then(data=>{
                    console.info(0);
                    Toast({
                        type:"success",
                        message: '删除成功',
                        onClose: ()=> {
                            if(this.$route.query.redirect) {
                                this.$router.replace({name:this.$route.query.redirect,});
                            } else {
                                //this.$router.replace({name:"address"});
                                this.goableBack();
                            }
                        }
                    });

                }).catch(e=>{
                    console.info(e);
                });
            }
        },
        components: {
            [Field.name]: Field,
            [SwitchCell.name]: SwitchCell,
            [Popup.name]: Popup,
            [Picker.name]: Picker,
            [Toast.name]: Toast,
        },
    }
</script>

<style lang="less" scoped>
    .page-container {
        padding-top: 0;
    }
</style>